import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {MatPaginator, MatSnackBar} from '@angular/material';
import {JsonEditorComponent, JsonEditorOptions} from 'ang-jsoneditor';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import {ConnecttocrudService} from '../connecttocrud.service';

declare let $;

@Component({
  selector: 'app-customoperation',
  templateUrl: './customoperation.component.html',
  styleUrls: ['./customoperation.component.css']
})
export class CustomoperationComponent implements OnInit {

  items: any;
  columns: string[] = [];
  itemname: string;
  navigate: any;
  searchText: any;
  itemLength: any;
  filterData: any[];
  settings = {text: 'Select attribute(s) to search instantly'};
  partner: string;
  account: string;
  operation: string;
  version: string;
  partnerKey: string;
  itemList: any[];
  options: any;
  userView = 'table';
  error = false;
  errorMessage: string;
  options1 = new JsonEditorOptions();
  @ViewChild(JsonEditorComponent) editor: JsonEditorComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(private _service: ConnecttocrudService,
              private location: Location,
              private route: ActivatedRoute,
              public snackBar: MatSnackBar) {
    this.options1.mode = 'code';
    this.options1.modes = ['code', 'text', 'tree', 'view'];
    this.options1.schema = '';
    this.options1.statusBar = false;
    this.options1.onChange = () => console.log(/* this.editor.get() */);

  }

  ngOnInit() {
    this.route.queryParams
        .subscribe(params => {
          this.partner = params.partner;
          this.account = params.account;
          this.operation = params.operation;
          this.version = params.version;
          this.partnerKey = localStorage.getItem('partnerKey');
          this.items = null;
          this.getitems();
        });
  }
  download() {
    $('.actions-crud').find('a:eq(2)').find('angular2csv').find('button').click();
  }

  getitems() {
    this.error = false;

    this._service.getItemsForOperation(this.version, this.partner, this.account, this.operation).subscribe(
        items => {
          this.items = items;
          this.itemLength = this.items.length;
          for (const item of this.items) {
            this.columns = [];
            for (const itemval in item) {
              this.columns.push(itemval);
            }
          }
          this.itemList = [];
          for (let t = 0; t < this.columns.length; t++) {
            const tempObj = {};
            tempObj['id'] = t;
            tempObj['itemName'] = this.columns[t];
            this.itemList.push(tempObj);
          }
          this.options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            headers: this.columns,
            showTitle: false,
            useBom: true,
            noDownload: false,
            nullToEmptyString: true,
            removeNewLines: false,
            keys: []
          };
        },
        error => { this.error = true; this.errorMessage = (error.error.message ? error.error.message : error.error); }
    );
  }
  getCSV(data) {
    alert('coming');
    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: this.operation,
      useBom: true,
      noDownload: true,
      headers: this.columns,
      nullToEmptyString: true,
    };
    return new ngxCsv(data, 'my Report');
  }

  typeOfval(val) {
    return typeof val;
  }

  stringifyjson(val) {
    return JSON.stringify(val, null, 2).trim();
  }


}
